import request from '#/utils/request';
import { parseVer4DetailResponse } from '#/api/adapters/envelope';
import {
  DASHBOARD_OVERVIEW_MODULE_KEYS,
  toDashboardOverviewDateParams,
} from './routes';

/**
 * GET `/dashboard/overview`：一次回傳已授權 module 的 `period`／`metrics`／`status_by_month`，
 * 有 `fms.dashboard_financial.read` 時金額 module 另有 `amounts`。未授權 module 的 key 由後端省略。
 * 另有 `backlog`（目前待辦，不受日期限制）與 `completion`（完成事件日期落在 completion_date_from/to）。
 * 共通日期區間同時映射為七組單據日期 query（舊 metrics／金額／分布）與 completion_date_from/to；
 * `trendMonths` → `trend_months`（月圖月數，後端預設 3）；`currencyId` 整頁共用，未帶時後端預設 TWD。
 *
 * @param {{ from?: string, to?: string } | null} range
 * @param {{ currencyId?: string | null, trendMonths?: number }} [options]
 */
export async function fetchDashboardOverview(range, { currencyId, trendMonths } = {}) {
  const params = DASHBOARD_OVERVIEW_MODULE_KEYS.reduce(
    (acc, moduleKey) => ({ ...acc, ...toDashboardOverviewDateParams(moduleKey, range) }),
    {},
  );
  if (range?.from && range?.to) {
    params.completion_date_from = range.from;
    params.completion_date_to = range.to;
  }
  if (trendMonths) {
    params.trend_months = trendMonths;
  }
  if (currencyId) {
    params.currency_id = currencyId;
  }
  const { data: raw } = await request.get('/dashboard/overview', { params });
  return parseVer4DetailResponse(raw);
}
